<div class="page-wrapper">
  <div class="page-header list-page-header mb-3">
    <div class="d-flex align-items-center gap-3">
      <button (click)="back()" class="btn-white">
        <svg
          width="7"
          height="6"
          viewBox="0 0 7 6"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6.67969 3.1737H1.41258L3.55632 5.07945L3.09831 5.48945L0.165782 2.8853L3.09831 0.27832L3.55632 0.688311L1.41258 2.59406H6.67969V3.1737Z"
            fill="#052B63"
          />
        </svg>
        Back
      </button>
      <h4 class="page-title">NEW MARRIAGE REGISTRATION</h4>
    </div>
  </div>

  <div class="page-content-wrapper" style="border-radius: 5px">
    <form [formGroup]="form">
      <div class="collapsable-form-section">
        <div
          class="collapsable-form-section-heading"
          role="button"
          data-bs-toggle="collapse"
          data-bs-target="#bachelorSection"
          aria-expanded="true"
        >
          BACHELOR DETAILS
        </div>

        <div class="body collapse show" id="bachelorSection">
          <div class="row g-3">
            <div class="col-md-4">
              <div class="field">
                <label class="mb-0 required">SURNAME</label>
                <input
                  type="text"
                  class="form-control mt-0"
                  formControlName="bachelorSurname"
                  maxlength="60"
                />
                <app-error-message
                  [form]="form"
                  controlName="bachelorSurname"
                  [showErrorMessage]="showErrorMessages"
                ></app-error-message>
              </div>
            </div>

            <div class="col-md-4">
              <div class="field">
                <label class="mb-0 required">FIRST NAME</label>
                <input
                  type="text"
                  class="form-control mt-0"
                  formControlName="bachelorFirstName"
                  maxlength="60"
                />
                <app-error-message
                  [form]="form"
                  controlName="bachelorFirstName"
                  [showErrorMessage]="showErrorMessages"
                ></app-error-message>
              </div>
            </div>

            <div class="col-md-4">
              <div class="field">
                <label class="mb-0">MIDDLE NAME</label>
                <input
                  type="text"
                  class="form-control mt-0"
                  formControlName="bachelorMiddleName"
                  maxlength="60"
                />
                <app-error-message
                  [form]="form"
                  controlName="bachelorMiddleName"
                  [showErrorMessage]="showErrorMessages"
                ></app-error-message>
              </div>
            </div>

            <div class="col-md-4">
              <div class="field">
                <label class="mb-0 required">DATE OF BIRTH</label>
                <input
                  type="date"
                  class="form-control mt-0"
                  formControlName="bachelorDob"
                  [attr.max]="today"
                />
                <app-error-message
                  [form]="form"
                  controlName="bachelorDob"
                  [showErrorMessage]="showErrorMessages"
                ></app-error-message>
              </div>
            </div>

            <div class="col-md-4">
              <div class="field">
                <label class="mb-0 required">PHONE NUMBER</label>
                <input
                  type="text"
                  class="form-control mt-0"
                  formControlName="bachelorPhoneNumber"
                  maxlength="17"
                />
                <app-error-message
                  [form]="form"
                  controlName="bachelorPhoneNumber"
                  [showErrorMessage]="showErrorMessages"
                ></app-error-message>
              </div>
            </div>

            <div class="col-md-4">
              <div class="field">
                <label class="mb-0 required">OCCUPATION</label>
                <input
                  type="text"
                  class="form-control mt-0"
                  formControlName="bachelorOccupation"
                  maxlength="30"
                />
                <app-error-message
                  [form]="form"
                  controlName="bachelorOccupation"
                  [showErrorMessage]="showErrorMessages"
                ></app-error-message>
              </div>
            </div>

            <div class="col-4">
              <div class="field">
                <label for="name" class="required">COUNTRY OF ORIGIN</label>
                @if (!countries) {
                  <ngx-skeleton-loader
                    class="input-skeleton"
                  ></ngx-skeleton-loader>
                } @else {
                  <ng-select
                    [items]="countries"
                    [multiple]="false"
                    [closeOnSelect]="true"
                    [searchable]="true"
                    [hideSelected]="false"
                    bindLabel="formattedName"
                    bindValue="id"
                    placeholder="Select"
                    formControlName="bachelorCountry"
                    class="ng-select control role-select"
                  >
                  </ng-select>
                }
              </div>
            </div>

            <div class="col-md-4">
              <div class="field">
                <label class="mb-0 required">STATE OF ORIGIN</label>

                @if (!states) {
                  <ngx-skeleton-loader
                    class="input-skeleton"
                  ></ngx-skeleton-loader>
                } @else {
                  <ng-select
                    [items]="states"
                    [multiple]="false"
                    [closeOnSelect]="true"
                    [searchable]="true"
                    [hideSelected]="false"
                    bindLabel="formattedName"
                    bindValue="id"
                    placeholder="Select"
                    formControlName="bachelorState"
                    (change)="loadLga($event)"
                    class="ng-select control role-select"
                  >
                  </ng-select>
                }
              </div>
            </div>

            <div class="col-md-4">
              <div class="field">
                <label class="mb-0 required">LGA OF ORIGIN</label>

                @if (!lgas) {
                  <ngx-skeleton-loader
                    class="input-skeleton"
                  ></ngx-skeleton-loader>
                } @else {
                  <ng-select
                    [items]="lgas"
                    [multiple]="false"
                    [closeOnSelect]="true"
                    [searchable]="true"
                    [hideSelected]="false"
                    bindLabel="formattedName"
                    bindValue="id"
                    placeholder="Select"
                    formControlName="bachelorLga"
                    class="ng-select control role-select"
                  >
                  </ng-select>
                }
              </div>
            </div>

            <div class="col-4">
              <div class="field">
                <label class="mb-0 required">ADDRESS</label>
                <input
                  type="text"
                  class="form-control mt-0"
                  formControlName="bachelorAddress"
                  maxlength="200"
                />
                <app-error-message
                  [form]="form"
                  controlName="bachelorAddress"
                  [showErrorMessage]="showErrorMessages"
                ></app-error-message>
              </div>
            </div>

            <div class="col-4">
              <div class="field">
                <label class="mb-0 required">LENGTH OF RESIDENCE</label>
                <input
                  type="number"
                  class="form-control mt-0"
                  formControlName="bachelorLengthOfResidence"
                  min="1"
                  max="100"
                />
                <app-error-message
                  [form]="form"
                  controlName="bachelorLengthOfResidence"
                  [showErrorMessage]="showErrorMessages"
                ></app-error-message>
              </div>
            </div>

            <div class="col-md-4">
              <div class="field">
                <label class="mb-0 required">UPLOAD SIGNATURE</label>
                <app-upload-input
                  [accept]="'.png, .jpg, .jpeg, .pdf'"
                  [maxFileSize]="1"
                  [isInPreviewMode]="false"
                  (fileChange)="onFileChange($event, 'bachelorSignature')"
                  (error)="onError($event, 'bachelorSignature')"
                  [form]="form"
                  controlName="bachelorSignature"
                ></app-upload-input>

                <app-error-message
                  [form]="form"
                  [maxFileSize]="1"
                  controlName="bachelorSignature"
                  label="Image upload"
                  [showErrorMessage]="showErrorMessages"
                ></app-error-message>
              </div>
            </div>

            <div class="col-md-4">
              <div class="field">
                <label class="mb-0 required">PASSPORT PHOTOGRAPH</label>
                <app-upload-input
                  [accept]="'.png, .jpg, .jpeg, .pdf'"
                  [maxFileSize]="1"
                  [isInPreviewMode]="false"
                  (fileChange)="
                    onFileChange($event, 'bachelorPassportPhotograph')
                  "
                  (error)="onError($event, 'bachelorPassportPhotograph')"
                  [form]="form"
                  controlName="bachelorPassportPhotograph"
                ></app-upload-input>

                <app-error-message
                  [form]="form"
                  [maxFileSize]="1"
                  controlName="bachelorPassportPhotograph"
                  label="Image upload"
                  [showErrorMessage]="showErrorMessages"
                ></app-error-message>
              </div>
            </div>

            <div class="col-md-4">
              <div class="field">
                <label class="mb-0 required">BIRTH CERTIFICATE</label>
                <app-upload-input
                  [accept]="'.png, .jpg, .jpeg, .pdf'"
                  [maxFileSize]="1"
                  [isInPreviewMode]="false"
                  (fileChange)="
                    onFileChange($event, 'bachelorBirthCertificate')
                  "
                  (error)="onError($event, 'bachelorBirthCertificate')"
                  [form]="form"
                  controlName="bachelorBirthCertificate"
                ></app-upload-input>

                <app-error-message
                  [form]="form"
                  [maxFileSize]="1"
                  controlName="bachelorBirthCertificate"
                  label="Image upload"
                  [showErrorMessage]="showErrorMessages"
                ></app-error-message>
              </div>
            </div>

            <div class="col-md-4">
              <div class="field">
                <label class="mb-0 required"
                  >DECLARATION / AFFIDAVIT OF AGE</label
                >
                <app-upload-input
                  [accept]="'.png, .jpg, .jpeg, .pdf'"
                  [maxFileSize]="1"
                  [isInPreviewMode]="false"
                  (fileChange)="
                    onFileChange($event, 'bachelorDeclarationOfAge')
                  "
                  (error)="onError($event, 'bachelorDeclarationOfAge')"
                  [form]="form"
                  controlName="bachelorDeclarationOfAge"
                ></app-upload-input>

                <app-error-message
                  [form]="form"
                  [maxFileSize]="1"
                  controlName="bachelorDeclarationOfAge"
                  label="Image upload"
                  [showErrorMessage]="showErrorMessages"
                ></app-error-message>
              </div>
            </div>

            <div class="col-md-4">
              <div class="field">
                <label class="mb-0 required"
                  >INDIGENE LETTER FROM STATE OF ORIGIN</label
                >
                <app-upload-input
                  [accept]="'.png, .jpg, .jpeg, .pdf'"
                  [maxFileSize]="1"
                  [isInPreviewMode]="false"
                  (fileChange)="
                    onFileChange($event, 'bachelorIndigeneCertificate')
                  "
                  (error)="onError($event, 'bachelorIndigeneCertificate')"
                  [form]="form"
                  controlName="bachelorIndigeneCertificate"
                ></app-upload-input>

                <app-error-message
                  [form]="form"
                  [maxFileSize]="1"
                  controlName="bachelorIndigeneCertificate"
                  label="Image upload"
                  [showErrorMessage]="showErrorMessages"
                ></app-error-message>
              </div>
            </div>

            <div class="col-md-4">
              <div class="field">
                <label class="mb-0"
                  >INTERNATIONAL PASSPORT (If Living Abroad)</label
                >
                <app-upload-input
                  [accept]="'.png, .jpg, .jpeg, .pdf'"
                  [maxFileSize]="1"
                  [isInPreviewMode]="false"
                  (fileChange)="
                    onFileChange($event, 'bachelorInternationalPassport')
                  "
                  (error)="onError($event, 'bachelorInternationalPassport')"
                  [form]="form"
                  controlName="bachelorInternationalPassport"
                ></app-upload-input>

                <app-error-message
                  [form]="form"
                  [maxFileSize]="1"
                  controlName="bachelorInternationalPassport"
                  label="Image upload"
                  [showErrorMessage]="showErrorMessages"
                ></app-error-message>
              </div>
            </div>

            <label class="checklist-item mt-4 mb-3">
              <input
                type="checkbox"
                formControlName="bachelorHasAnotherMarriage"
              />
              <small style="font-size: 15px">Has been married?</small>
            </label>

            <label class="checklist-item mt-4 mb-3">
              <input type="checkbox" formControlName="bachelorIsWidower" />
              <small style="font-size: 15px">Is a widower?</small>
            </label>

            <label class="checklist-item mt-4 mb-3">
              <input type="checkbox" formControlName="bachelorHasChild" />
              <small style="font-size: 15px">Has a child or children?</small>
            </label>

            <label class="checklist-item mt-4 mb-3">
              <input type="checkbox" formControlName="bachelorIsDivorce" />
              <small style="font-size: 15px">Is a divorcee?</small>
            </label>
          </div>

          <div class="form-section mt-4">
            <h5 class="form-section-heading mb-3">WITNESS DETAILS</h5>
            <div class="body">
              <div class="row g-3">
                <div class="col-md-4">
                  <div class="field">
                    <label class="mb-0 required">SURNAME</label>
                    <input
                      type="text"
                      class="form-control mt-0"
                      formControlName="bachelorWitnessSurname"
                      maxlength="60"
                    />
                    <app-error-message
                      [form]="form"
                      controlName="bachelorWitnessSurname"
                      [showErrorMessage]="showErrorMessages"
                    ></app-error-message>
                  </div>
                </div>

                <div class="col-md-4">
                  <div class="field">
                    <label class="mb-0 required">FIRST NAME</label>
                    <input
                      type="text"
                      class="form-control mt-0"
                      formControlName="bachelorWitnessFirstName"
                      maxlength="60"
                    />
                    <app-error-message
                      [form]="form"
                      controlName="bachelorWitnessFirstName"
                      [showErrorMessage]="showErrorMessages"
                    ></app-error-message>
                  </div>
                </div>

                <div class="col-md-4">
                  <div class="field">
                    <label class="mb-0">MIDDLE NAME</label>
                    <input
                      type="text"
                      class="form-control mt-0"
                      formControlName="bachelorWitnessMiddleName"
                      maxlength="60"
                    />
                    <app-error-message
                      [form]="form"
                      controlName="bachelorWitnessMiddleName"
                      [showErrorMessage]="showErrorMessages"
                    ></app-error-message>
                  </div>
                </div>

                <div class="col-md-4">
                  <div class="field">
                    <label class="mb-0 required">PHONE NUMBER</label>
                    <input
                      type="text"
                      class="form-control mt-0"
                      formControlName="bachelorWitnessPhoneNumber"
                      maxlength="17"
                    />
                    <app-error-message
                      [form]="form"
                      controlName="bachelorWitnessPhoneNumber"
                      [showErrorMessage]="showErrorMessages"
                    ></app-error-message>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="field">
                    <label class="mb-0">EMAIL</label>
                    <input
                      type="text"
                      class="form-control mt-0"
                      formControlName="bachelorWitnessEmail"
                      maxlength="30"
                    />
                    <app-error-message
                      [form]="form"
                      controlName="bachelorWitnessEmail"
                      [showErrorMessage]="showErrorMessages"
                    ></app-error-message>
                  </div>
                </div>

                <div class="col-4">
                  <div class="field">
                    <label class="mb-0 required">ADDRESS</label>
                    <input
                      type="text"
                      class="form-control mt-0"
                      formControlName="bachelorWitnessAddress"
                      maxlength="200"
                    />
                    <app-error-message
                      [form]="form"
                      controlName="bachelorWitnessAddress"
                      [showErrorMessage]="showErrorMessages"
                    ></app-error-message>
                  </div>
                </div>

                <div class="col-md-4">
                  <div class="field">
                    <label class="mb-0 required">UPLOAD SIGNATURE</label>
                    <app-upload-input
                      [accept]="'.png, .jpg, .jpeg, .pdf'"
                      [maxFileSize]="1"
                      [isInPreviewMode]="false"
                      (fileChange)="
                        onFileChange($event, 'bachelorWitnessSignature')
                      "
                      (error)="onError($event, 'bachelorWitnessSignature')"
                      [form]="form"
                      controlName="bachelorWitnessSignature"
                    ></app-upload-input>

                    <app-error-message
                      [form]="form"
                      [maxFileSize]="1"
                      controlName="bachelorWitnessSignature"
                      label="Image upload"
                      [showErrorMessage]="showErrorMessages"
                    ></app-error-message>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="collapsable-form-section">
        <div
          class="collapsable-form-section-heading"
          role="button"
          data-bs-toggle="collapse"
          data-bs-target="#spinsterSection"
          aria-expanded="true"
        >
          SPINSTER DETAILS
        </div>

        <div class="body collapse show" id="spinsterSection">
          <div class="row g-3 MB-3">
            <div class="col-md-4">
              <div class="field">
                <label class="mb-0 required">SURNAME</label>
                <input
                  type="text"
                  class="form-control mt-0"
                  formControlName="spinsterSurname"
                  maxlength="60"
                />
                <app-error-message
                  [form]="form"
                  controlName="spinsterSurname"
                  [showErrorMessage]="showErrorMessages"
                ></app-error-message>
              </div>
            </div>

            <div class="col-md-4">
              <div class="field">
                <label class="mb-0 required">FIRST NAME</label>
                <input
                  type="text"
                  class="form-control mt-0"
                  formControlName="spinsterFirstName"
                  maxlength="60"
                />
                <app-error-message
                  [form]="form"
                  controlName="spinsterFirstName"
                  [showErrorMessage]="showErrorMessages"
                ></app-error-message>
              </div>
            </div>

            <div class="col-md-4">
              <div class="field">
                <label class="mb-0">MIDDLE NAME</label>
                <input
                  type="text"
                  class="form-control mt-0"
                  formControlName="spinsterMiddleName"
                  maxlength="60"
                />
                <app-error-message
                  [form]="form"
                  controlName="spinsterMiddleName"
                  [showErrorMessage]="showErrorMessages"
                ></app-error-message>
              </div>
            </div>

            <div class="col-md-4">
              <div class="field">
                <label class="mb-0 required">DATE OF BIRTH</label>
                <input
                  type="date"
                  class="form-control mt-0"
                  formControlName="spinsterDob"
                  [attr.max]="today"
                />
                <app-error-message
                  [form]="form"
                  controlName="spinsterDob"
                  [showErrorMessage]="showErrorMessages"
                ></app-error-message>
              </div>
            </div>

            <div class="col-md-4">
              <div class="field">
                <label class="mb-0 required">PHONE NUMBER</label>
                <input
                  type="text"
                  class="form-control mt-0"
                  formControlName="spinsterPhoneNumber"
                  maxlength="17"
                />
                <app-error-message
                  [form]="form"
                  controlName="spinsterPhoneNumber"
                  [showErrorMessage]="showErrorMessages"
                ></app-error-message>
              </div>
            </div>

            <div class="col-md-4">
              <div class="field">
                <label class="mb-0 required">OCCUPATION</label>
                <input
                  type="text"
                  class="form-control mt-0"
                  formControlName="spinsterOccupation"
                  maxlength="30"
                />
                <app-error-message
                  [form]="form"
                  controlName="spinsterOccupation"
                  [showErrorMessage]="showErrorMessages"
                ></app-error-message>
              </div>
            </div>

            <div class="col-md-4">
              <div class="field">
                <label class="mb-0 required">CONSENT GRANTED BY:</label>
                <input
                  type="text"
                  class="form-control mt-0"
                  formControlName="consent"
                  maxlength="50"
                />
                <app-error-message
                  [form]="form"
                  controlName="consent"
                  [showErrorMessage]="showErrorMessages"
                ></app-error-message>
              </div>
            </div>

            <div class="col-4">
              <div class="field">
                <label for="name" class="required">COUNTRY OF ORIGIN</label>
                @if (!countries) {
                  <ngx-skeleton-loader
                    class="input-skeleton"
                  ></ngx-skeleton-loader>
                } @else {
                  <ng-select
                    [items]="countries"
                    [multiple]="false"
                    [closeOnSelect]="true"
                    [searchable]="true"
                    [hideSelected]="false"
                    bindLabel="formattedName"
                    bindValue="id"
                    placeholder="Select"
                    formControlName="spinsterCountry"
                    class="ng-select control role-select"
                  >
                  </ng-select>
                }
              </div>
            </div>

            <div class="col-md-4">
              <div class="field">
                <label class="mb-0 required">STATE OF ORIGIN</label>
                @if (!states) {
                  <ngx-skeleton-loader
                    class="input-skeleton"
                  ></ngx-skeleton-loader>
                } @else {
                  <ng-select
                    [items]="states"
                    [multiple]="false"
                    [closeOnSelect]="true"
                    [searchable]="true"
                    [hideSelected]="false"
                    bindLabel="formattedName"
                    bindValue="id"
                    placeholder="Select"
                    formControlName="spinsterState"
                    (change)="loadLga($event)"
                    class="ng-select control role-select"
                  >
                  </ng-select>
                }
              </div>
            </div>

            <div class="col-md-4">
              <div class="field">
                <label class="mb-0 required">LGA OF ORIGIN</label>
                @if (!lgas) {
                  <ngx-skeleton-loader
                    class="input-skeleton"
                  ></ngx-skeleton-loader>
                } @else {
                  <ng-select
                    [items]="lgas"
                    [multiple]="false"
                    [closeOnSelect]="true"
                    [searchable]="true"
                    [hideSelected]="false"
                    bindLabel="formattedName"
                    bindValue="id"
                    placeholder="Select"
                    formControlName="spinsterLga"
                    class="ng-select control role-select"
                  >
                  </ng-select>
                }
              </div>
            </div>

            <div class="col-4">
              <div class="field">
                <label class="mb-0 required">ADDRESS</label>
                <input
                  type="text"
                  class="form-control mt-0"
                  formControlName="spinsterAddress"
                  maxlength="200"
                />
                <app-error-message
                  [form]="form"
                  controlName="spinsterAddress"
                  [showErrorMessage]="showErrorMessages"
                ></app-error-message>
              </div>
            </div>

            <div class="col-4">
              <div class="field">
                <label class="mb-0 required">LENGTH OF RESIDENCE</label>
                <input
                  type="number"
                  class="form-control mt-0"
                  formControlName="spinsterLengthOfResidence"
                  min="1"
                  max="100"
                />
                <app-error-message
                  [form]="form"
                  controlName="spinsterLengthOfResidence"
                  [showErrorMessage]="showErrorMessages"
                ></app-error-message>
              </div>
            </div>

            <div class="col-md-4">
              <div class="field">
                <label class="mb-0 required">UPLOAD SIGNATURE</label>
                <app-upload-input
                  [accept]="'.png, .jpg, .jpeg, .pdf'"
                  [maxFileSize]="1"
                  [isInPreviewMode]="false"
                  (fileChange)="onFileChange($event, 'spinsterSignature')"
                  (error)="onError($event, 'spinsterSignature')"
                  [form]="form"
                  controlName="spinsterSignature"
                ></app-upload-input>

                <app-error-message
                  [form]="form"
                  [maxFileSize]="1"
                  controlName="spinsterSignature"
                  label="Image upload"
                  [showErrorMessage]="showErrorMessages"
                ></app-error-message>
              </div>
            </div>

            <div class="col-md-4">
              <div class="field">
                <label class="mb-0 required">PASSPORT PHOTOGRAPH</label>
                <app-upload-input
                  [accept]="'.png, .jpg, .jpeg, .pdf'"
                  [maxFileSize]="1"
                  [isInPreviewMode]="false"
                  (fileChange)="
                    onFileChange($event, 'spinsterPassportPhotograph')
                  "
                  (error)="onError($event, 'spinsterPassportPhotograph')"
                  [form]="form"
                  controlName="spinsterPassportPhotograph"
                ></app-upload-input>

                <app-error-message
                  [form]="form"
                  [maxFileSize]="1"
                  controlName="spinsterPassportPhotograph"
                  label="Image upload"
                  [showErrorMessage]="showErrorMessages"
                ></app-error-message>
              </div>
            </div>

            <div class="col-md-4">
              <div class="field">
                <label class="mb-0 required">BIRTH CERTIFICATE</label>
                <app-upload-input
                  [accept]="'.png, .jpg, .jpeg, .pdf'"
                  [maxFileSize]="1"
                  [isInPreviewMode]="false"
                  (fileChange)="
                    onFileChange($event, 'spinsterBirthCertificate')
                  "
                  (error)="onError($event, 'spinsterBirthCertificate')"
                  [form]="form"
                  controlName="spinsterBirthCertificate"
                ></app-upload-input>

                <app-error-message
                  [form]="form"
                  [maxFileSize]="1"
                  controlName="spinsterBirthCertificate"
                  label="Image upload"
                  [showErrorMessage]="showErrorMessages"
                ></app-error-message>
              </div>
            </div>

            <div class="col-md-4">
              <div class="field">
                <label class="mb-0 required"
                  >DECLARATION / AFFIDAVIT OF AGE</label
                >
                <app-upload-input
                  [accept]="'.png, .jpg, .jpeg, .pdf'"
                  [maxFileSize]="1"
                  [isInPreviewMode]="false"
                  (fileChange)="
                    onFileChange($event, 'spinsterDeclarationOfAge')
                  "
                  (error)="onError($event, 'spinsterDeclarationOfAge')"
                  [form]="form"
                  controlName="spinsterDeclarationOfAge"
                ></app-upload-input>

                <app-error-message
                  [form]="form"
                  [maxFileSize]="1"
                  controlName="spinsterDeclarationOfAge"
                  label="Image upload"
                  [showErrorMessage]="showErrorMessages"
                ></app-error-message>
              </div>
            </div>

            <div class="col-md-4">
              <div class="field">
                <label class="mb-0 required"
                  >INDIGENE LETTER FROM STATE OF ORIGIN</label
                >
                <app-upload-input
                  [accept]="'.png, .jpg, .jpeg, .pdf'"
                  [maxFileSize]="1"
                  [isInPreviewMode]="false"
                  (fileChange)="
                    onFileChange($event, 'spinsterIndigeneCertificate')
                  "
                  (error)="onError($event, 'spinsterIndigeneCertificate')"
                  [form]="form"
                  controlName="spinsterIndigeneCertificate"
                ></app-upload-input>

                <app-error-message
                  [form]="form"
                  [maxFileSize]="1"
                  controlName="spinsterIndigeneCertificate"
                  label="Image upload"
                  [showErrorMessage]="showErrorMessages"
                ></app-error-message>
              </div>
            </div>

            <div class="col-md-4">
              <div class="field">
                <label class="mb-0"
                  >INTERNATIONAL PASSPORT (If Living Abroad)</label
                >
                <app-upload-input
                  [accept]="'.png, .jpg, .jpeg, .pdf'"
                  [maxFileSize]="1"
                  [isInPreviewMode]="false"
                  (fileChange)="
                    onFileChange($event, 'spinsterInternationalPassport')
                  "
                  (error)="onError($event, 'spinsterInternationalPassport')"
                  [form]="form"
                  controlName="spinsterInternationalPassport"
                ></app-upload-input>

                <app-error-message
                  [form]="form"
                  [maxFileSize]="1"
                  controlName="spinsterInternationalPassport"
                  label="Image upload"
                  [showErrorMessage]="showErrorMessages"
                ></app-error-message>
              </div>
            </div>

            <label class="checklist-item mt-4 mb-3">
              <input
                type="checkbox"
                formControlName="spinsterHasAnotherMarriage"
              />
              <small style="font-size: 15px">Has been married?</small>
            </label>

            <label class="checklist-item mt-4 mb-3">
              <input type="checkbox" formControlName="spinsterIsWidow" />
              <small style="font-size: 15px">Is a widow?</small>
            </label>

            <label class="checklist-item mt-4 mb-3">
              <input type="checkbox" formControlName="spinsterHasChild" />
              <small style="font-size: 15px">Has a child or children?</small>
            </label>

            <label class="checklist-item mt-4 mb-3">
              <input type="checkbox" formControlName="spinsterIsDivorce" />
              <small style="font-size: 15px">Is a divorcee?</small>
            </label>
          </div>

          <div class="form-section mt-4">
            <h5 class="form-section-heading mb-3">WITNESS DETAILS</h5>
            <div class="body">
              <div class="row g-3">
                <div class="col-md-4">
                  <div class="field">
                    <label class="mb-0 required">SURNAME</label>
                    <input
                      type="text"
                      class="form-control mt-0"
                      formControlName="spinsterWitnessSurname"
                      maxlength="60"
                    />
                    <app-error-message
                      [form]="form"
                      controlName="spinsterWitnessSurname"
                      [showErrorMessage]="showErrorMessages"
                    ></app-error-message>
                  </div>
                </div>

                <div class="col-md-4">
                  <div class="field">
                    <label class="mb-0 required">FIRST NAME</label>
                    <input
                      type="text"
                      class="form-control mt-0"
                      formControlName="spinsterWitnessFirstName"
                      maxlength="60"
                    />
                    <app-error-message
                      [form]="form"
                      controlName="spinsterWitnessFirstName"
                      [showErrorMessage]="showErrorMessages"
                    ></app-error-message>
                  </div>
                </div>

                <div class="col-md-4">
                  <div class="field">
                    <label class="mb-0">MIDDLE NAME</label>
                    <input
                      type="text"
                      class="form-control mt-0"
                      formControlName="spinsterWitnessMiddleName"
                      maxlength="60"
                    />
                    <app-error-message
                      [form]="form"
                      controlName="spinsterWitnessMiddleName"
                      [showErrorMessage]="showErrorMessages"
                    ></app-error-message>
                  </div>
                </div>

                <div class="col-md-4">
                  <div class="field">
                    <label class="mb-0">EMAIL</label>
                    <input
                      type="text"
                      class="form-control mt-0"
                      formControlName="spinsterWitnessEmail"
                      maxlength="30"
                    />
                    <app-error-message
                      [form]="form"
                      controlName="spinsterWitnessEmail"
                      [showErrorMessage]="showErrorMessages"
                    ></app-error-message>
                  </div>
                </div>

                <div class="col-md-4">
                  <div class="field">
                    <label class="mb-0 required">PHONE NUMBER</label>
                    <input
                      type="text"
                      class="form-control mt-0"
                      formControlName="spinsterWitnessPhoneNumber"
                      maxlength="17"
                    />
                    <app-error-message
                      [form]="form"
                      controlName="spinsterWitnessPhoneNumber"
                      [showErrorMessage]="showErrorMessages"
                    ></app-error-message>
                  </div>
                </div>

                <div class="col-4">
                  <div class="field">
                    <label class="mb-0 required">ADDRESS</label>
                    <input
                      type="text"
                      class="form-control mt-0"
                      formControlName="spinsterWitnessAddress"
                      maxlength="200"
                    />
                    <app-error-message
                      [form]="form"
                      controlName="spinsterWitnessAddress"
                      [showErrorMessage]="showErrorMessages"
                    ></app-error-message>
                  </div>
                </div>

                <div class="col-md-4">
                  <div class="field">
                    <label class="mb-0 required">UPLOAD SIGNATURE</label>
                    <app-upload-input
                      [accept]="'.png, .jpg, .jpeg, .pdf'"
                      [maxFileSize]="1"
                      [isInPreviewMode]="false"
                      (fileChange)="
                        onFileChange($event, 'spinsterWitnessSignature')
                      "
                      (error)="onError($event, 'spinsterWitnessSignature')"
                      [form]="form"
                      controlName="spinsterWitnessSignature"
                    ></app-upload-input>

                    <app-error-message
                      [form]="form"
                      [maxFileSize]="1"
                      controlName="spinsterWitnessSignature"
                      label="Image upload"
                      [showErrorMessage]="showErrorMessages"
                    ></app-error-message>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="collapsable-form-section">
        <div
          class="collapsable-form-section-heading"
          role="button"
          data-bs-toggle="collapse"
          data-bs-target="#documentSection"
          aria-expanded="true"
        >
          DOCUMENT UPLOADS
        </div>

        <div class="body collapse show" id="documentSection">
          <div class="form-section mt-4">
            <h5 class="form-section-heading mb-3">DOCUMENT UPLOADS</h5>

            <div
              style="
                background-color: #fdfef5;
                border: 1px solid #e6e8a7;
                border-radius: 8px;
                padding: 12px 20px;
                margin-bottom: 30px;
              "
            >
              <span class="ms-3" style="color: #046b32"
                >Document size should not exceed 5MB.</span
              >
            </div>

            <div class="card p-3">
              <div class="row d-flex align-items-center">
                <div class="col">
                  <div
                    class="d-flex gap-2 align-items-center justify-content-start"
                  >
                    <label
                      for="motorcycle_picture"
                      class="upload-btn d-flex justify-content-center"
                    >
                      <span>
                        <svg
                          width="17"
                          height="17"
                          viewBox="0 0 14 14"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M3.03479 12.0983C2.85302 12.0983 2.6787 12.0261 2.55017 11.8976C2.42164 11.7691 2.34943 11.5947 2.34943 11.413V3.18857C2.34943 3.0068 2.42164 2.83247 2.55017 2.70394C2.6787 2.57541 2.85302 2.5032 3.03479 2.5032H11.2592C11.441 2.5032 11.6153 2.57541 11.7438 2.70394C11.8723 2.83247 11.9445 3.0068 11.9445 3.18857V11.413C11.9445 11.5947 11.8723 11.7691 11.7438 11.8976C11.6153 12.0261 11.441 12.0983 11.2592 12.0983H8.17504C7.99327 12.0983 7.81894 12.0261 7.69041 11.8976C7.56188 11.7691 7.48967 11.5947 7.48967 11.413V6.41459L9.30315 8.22875C9.3675 8.2931 9.45477 8.32925 9.54577 8.32925C9.63677 8.32925 9.72404 8.2931 9.78839 8.22875C9.85274 8.1644 9.88888 8.07713 9.88888 7.98613C9.88888 7.89513 9.85274 7.80786 9.78839 7.74351L7.38961 5.34473C7.35778 5.31282 7.31996 5.2875 7.27833 5.27022C7.2367 5.25295 7.19206 5.24406 7.14699 5.24406C7.10191 5.24406 7.05728 5.25295 7.01565 5.27022C6.97402 5.2875 6.9362 5.31282 6.90437 5.34473L4.50559 7.74351C4.47373 7.77537 4.44845 7.8132 4.43121 7.85483C4.41397 7.89645 4.40509 7.94107 4.40509 7.98613C4.40509 8.03119 4.41397 8.07581 4.43121 8.11744C4.44845 8.15906 4.47373 8.19689 4.50559 8.22875C4.53745 8.26061 4.57527 8.28589 4.6169 8.30313C4.65853 8.32037 4.70315 8.32925 4.74821 8.32925C4.79327 8.32925 4.83788 8.32037 4.87951 8.30313C4.92114 8.28589 4.95897 8.26061 4.99083 8.22875L6.80431 6.41459V11.413C6.80431 11.7765 6.94872 12.1252 7.20578 12.3822C7.46285 12.6393 7.8115 12.7837 8.17504 12.7837H11.2592C11.6227 12.7837 11.9714 12.6393 12.2284 12.3822C12.4855 12.1252 12.6299 11.7765 12.6299 11.413V3.18857C12.6299 2.82503 12.4855 2.47638 12.2284 2.21932C11.9714 1.96225 11.6227 1.81784 11.2592 1.81784H3.03479C2.67125 1.81784 2.3226 1.96225 2.06554 2.21932C1.80848 2.47638 1.66406 2.82503 1.66406 3.18857V11.413C1.66406 11.7765 1.80848 12.1252 2.06554 12.3822C2.3226 12.6393 2.67125 12.7837 3.03479 12.7837H4.74821C4.83909 12.7837 4.92626 12.7476 4.99052 12.6833C5.05479 12.6191 5.09089 12.5319 5.09089 12.441C5.09089 12.3501 5.05479 12.263 4.99052 12.1987C4.92626 12.1344 4.83909 12.0983 4.74821 12.0983H3.03479Z"
                            fill="white"
                          />
                        </svg>
                      </span>
                      Upload
                      <input
                        type="file"
                        (change)="
                          handleFileUpload($event, 'oathCertificate', 1)
                        "
                        accept="image/*"
                        id="motorcycle_picture"
                        hidden
                      />
                    </label>
                    <span class="required">Registration of Oath</span>
                  </div>
                </div>

                <div
                  class="d-flex col flex-column gap-1 justify-content-end text-end"
                >
                  @if (!oathCertificateUploadControl?.value?.file) {
                    <div
                      class="d-flex justify-content-end gap-1 justify-content-end"
                      *ngIf="
                        !oathCertificateUploadControl?.touched &&
                        !showErrorMessages
                      "
                    >
                      No File Uploaded
                    </div>

                    <app-error-message
                      controlName="oathCertificate"
                      [showErrorMessage]="showErrorMessages"
                      [form]="form"
                    ></app-error-message>
                  } @else {
                    <span class="file-name">
                      {{ oathCertificateUploadControl?.value?.file?.name }}
                    </span>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>

    <div
      *ngIf="hasAccess(['CAN_CREATE_MARRIAGE_REGISTRATION'])"
      class="button-container"
    >
      <button
        *ngIf="previewed"
        type="button"
        class="btn btn-secondary flex-btn"
        (click)="enableEdit()"
      >
        Edit
      </button>

      <button
        class="custom-btn-primary flex-btn"
        (click)="previewed ? openConfirmModal() : previewForm()"
        [disabled]="!form.dirty || form.invalid || isSubmitting"
      >
        <ng-container *ngIf="!isSubmitting; else loadingTemplate2">
          <span *ngIf="!previewed">Preview</span>
          <span *ngIf="previewed">Submit</span>
        </ng-container>
        <ng-template #loadingTemplate2>
          <span>Saving please wait...</span>
          <div class="spinner-light"></div>
        </ng-template>
        <svg
          width="15"
          height="19"
          viewBox="0 0 15 19"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11.7955 10.6013C9.12344 9.72003 9.18029 8.86723 8.75389 9.26521C8.75389 9.00937 8.78232 8.75353 8.81074 8.49769C9.37928 7.92915 9.8341 7.10478 10.0331 6.13827C10.1184 5.99613 10.2321 5.88243 10.3174 5.51288C10.6585 4.40424 10.2321 4.29053 10.2037 4.2621C10.2889 3.86413 10.4311 2.78392 10.2321 2.18695C9.8341 0.964606 7.64525 0.253938 7.16199 0.140231C6.28076 -0.257743 4.31932 0.794045 3.86449 2.18695C3.66551 2.78392 3.80764 3.8357 3.89292 4.2621C3.46652 4.63165 3.75079 5.62659 4.00663 6.05299C3.80764 6.36568 3.46652 7.07635 3.80764 7.61646C4.00663 7.92915 4.4046 8.07129 4.97314 8.07129C5.08684 8.24185 5.22898 8.38398 5.37111 8.52611C5.39954 8.75353 5.39954 9.00937 5.39954 9.26521C5.28583 9.1515 5.11527 9.1515 5.00156 9.26521C5.00156 9.26521 4.20561 10.0327 2.35788 10.6297C-0.456367 11.6815 0.0268875 15.6044 0.169021 16.4003V16.4287C0.282728 17.0541 0.339581 17.2247 0.510142 17.31C3.46652 18.6176 10.7153 18.6176 13.6433 17.31C13.8423 17.2247 13.8991 17.0541 14.0128 16.4287C14.0128 16.4003 14.0128 16.4003 14.0128 16.3719V16.4003C14.1265 15.5759 14.6382 11.6815 11.7955 10.6013ZM4.4046 2.35751C4.7173 1.44786 6.05335 0.538205 6.76402 0.623485C7.61682 0.765619 9.4077 1.53314 9.69197 2.35751C9.80568 2.72706 9.74883 3.4093 9.69197 3.86413C7.64525 3.66514 6.8493 2.30066 6.82087 2.24381C6.76402 2.15853 6.67874 2.10167 6.56503 2.10167C6.45132 2.10167 6.36604 2.15853 6.30919 2.27223C5.96807 2.95448 5.05842 3.52301 4.37618 3.86413C4.34775 3.38088 4.29089 2.72706 4.4046 2.35751ZM4.26247 7.27534C4.17719 7.16163 4.20562 6.99107 4.26247 6.82051C4.34775 7.04792 4.43303 7.24691 4.54674 7.4459C4.37618 7.38904 4.29089 7.33219 4.26247 7.27534ZM8.18536 8.98094V9.72004C7.38941 10.2317 6.70717 10.2033 5.93964 9.72004C5.93964 9.4642 5.96807 9.23678 5.93964 8.98094C6.67874 9.40734 7.41783 9.43577 8.18536 8.98094ZM13.4443 16.2582C13.3874 16.5709 13.359 16.713 13.3306 16.7699C10.4879 17.9638 3.66551 17.9638 0.822836 16.7699C0.794409 16.713 0.765982 16.5709 0.709129 16.2582V16.2298C0.595422 15.5191 0.140594 12.0226 2.52844 11.1129C3.9782 10.6297 4.831 10.0896 5.17212 9.80532C6.4229 10.914 7.73053 10.914 8.95288 9.80532C9.32242 10.0896 10.1468 10.6297 11.5966 11.1129C14.0128 12.051 13.558 15.5759 13.4443 16.2582Z"
            fill="white"
          />
        </svg>
      </button>
    </div>
  </div>
</div>
